import React, { useMemo } from 'react';
import { IconButton, type SxProps, type Theme, useTheme } from '@mui/material';

import CircleChevronLeft from '@/assets/icons/circle-chevron-left.svg?react';
import { useDirection } from '@/hooks/useDirection';
import { transforms } from '@/theme/constants';

type CollapseButtonProps = {
  onClick: () => void;
  isOpen: boolean;
  mirrored?: boolean;
  sx?: SxProps<Theme>;
};

const CollapseButton = ({ onClick, isOpen, mirrored = false, sx = {} }: CollapseButtonProps) => {
  const { isRtl } = useDirection();
  const { palette } = useTheme();

  const iconTransform = useMemo(() => {
    const mirrorDirection = !mirrored ? isRtl === isOpen : isRtl !== isOpen;

    return transforms.compose(
      ...[transforms.shift50X(isRtl !== mirrored), transforms.mirrorX(mirrorDirection)].filter(Boolean)
    );
  }, [isOpen, isRtl, mirrored]);

  return (
    <IconButton
      className="MuiCollapseButton-root"
      disableRipple
      sx={{
        p: 0,
        transform: iconTransform,
        ...sx,

        ['& .circle, & .chevron']: {
          stroke: palette.grey[700],
          fill: palette.background.default
        },

        [`&:hover .chevron, &:focus-visible .chevron,
          &:hover .circle, &:focus-visible .circle`]: {
          fill: palette.primary[100],
          stroke: palette.primary[700]
        }
      }}
      onClick={onClick}
    >
      <CircleChevronLeft />
    </IconButton>
  );
};

export default CollapseButton;
